import React, {ErrorInfo, PureComponent, ReactNode} from 'react';

import {reportToBugsnag} from '../../../../srcCommon/services/bugsnag/bugsnag';
import {MessageModel} from '../../../models/api/messageModel';
import {TimelineVariationsEnum} from '../../../store/timelineVariations/timelineVariationSelectors';
import {ComposerErrorFallback} from './composerErrorFallback';

/*
 * Props.
 */

interface ComposerErrorBoundaryProps {
  message: MessageModel;
  children: ReactNode;
  timelineVariation: TimelineVariationsEnum;
}

/*
 * Component.
 */

interface ComposerErrorBoundaryState {
  error?: unknown;
}

export class ComposerErrorBoundary extends PureComponent<
  ComposerErrorBoundaryProps,
  ComposerErrorBoundaryState
> {
  constructor(props: ComposerErrorBoundaryProps) {
    super(props);

    this.state = {};
  }

  static getDerivedStateFromError(error: unknown) {
    return {error};
  }

  componentDidCatch(error: Error, _errorInfo: ErrorInfo) {
    reportToBugsnag(error, {
      metadata: {
        messageUid: this.props.message.uid,
      },
    });
  }

  render() {
    if (this.state.error) {
      return (
        <ComposerErrorFallback
          message={this.props.message}
          timelineVariation={this.props.timelineVariation}
        />
      );
    }

    return this.props.children;
  }
}
